export default {
    header: 'היסטוריה',
}
